<template>
  <div class="tw-whitespace-nowrap" :data-test="`tc-business-${index}`">
    {{ businessSetup || '' }}
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const TrustedContactBusinessSetupColumn = graphql(`
  fragment TrustedContactBusinessSetupColumn on TrustedContact {
    id
    worker {
      id
      primaryBusinessEntity {
        name
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof TrustedContactBusinessSetupColumn>, index: number }>()
const column = computed(() => useFragment(TrustedContactBusinessSetupColumn, props.row))
const businessSetup = computed(() => column.value.worker.primaryBusinessEntity?.name ?? null)
</script>

<style scoped></style>
